/**
                        * Created by xnr on 2020-04-02.
                    */
import request from '../utils/fetch'
//修改配置
export function update (data) {
  return request({
    url: '/config/update',
    method: 'post',
    requestBody: 'body',
    loading: true,
    data: data
  })
}
//新增配置
export function add (data) {
  return request({
    url: '/config/add',
    method: 'post',
    requestBody: 'body',
    loading: true,
    data: data
  })
}
//不分页,角色列表
export function list (data) {
  return request({
    url: '/config/list',
    method: 'get',
    requestBody: 'null',
    loading: true,
    params: data
  })
}
